import {PortalDocument} from './PortalDocument';

export class Employee {
    id: number;
    name: string;
    surname: string;
    jobTitlename: string;
    workStartDate: string;
    tck: number;
    tel: string;
    email: string;
    jobTitle: any;
    department: any;
    parentDepartment: any;
    manager: any;
    approvalManager: any;
    profilePhoto?: PortalDocument;
    birthDate: string;
    gender: string ;
    endDate: string ;
    personalNo: string;
    mealCardNo: string;
}
